<template>
    <div class="dateHotel">
        <div class="topNav clearfix topDis">
            <div class="nav time">
                <datepik @change='dateChange' :limit="limit" :defaultValue="dateValue"></datepik>
            </div>
        </div>
    </div>
</template>
<script>
import search from './search'
import _ from 'lodash'
import moment from 'moment'
export default {
    name:'datehotel',
    data() {
        return {
            hotel: {},
            dateValue:this.defaultDate != null && this.defaultDate != '' ? this.defaultDate: moment().add('d', this.datediff).format('YYYY-MM-DD'),
            showFlag:'none',
        }
    },
    props: {
        defaultDate: {default:  null},
        defaultHotel:{default: null},
        datediff:{default:-1},
        limit:{
                default:'pre'
            }
        },
    mounted() {
        // setTimeout((()=>{console.log(this.defaultDate)}),1000)
    },
    methods: {
        // 选择时间
        dateChange(time) {
            this.$emit('getDate',time);
        },
        setNewDate(d){
            console.log(d);
           this.dateValue =  moment(d).format('YYYY-MM-DD');
        },
        //选择酒店
        getsearch(item) {
            this.hotel = item;
            // this.Report.code = item.code;
            this.showFlag = 'none'
            this.$emit('getHotel',item)
        },
    },
    computed: {
        defHotel(){
            if(!this.hotel.descript)
            this.hotel.descript=this.defaultHotel
            return this.hotel.descript;
        }
    },
    components: {
        search,
    }
}
</script>
<style lang='less' >
.dateHotel {
    .topNav {
        height: 1.1rem;
        background-color: #fff;
        width: 100%;
        box-sizing: border-box;
        padding: 0 0.5333rem;
        .nav {
            position: relative;
            height: 100%;
           // float: left;
           margin: 0 auto;
            z-index: 1;
            line-height: 1.1rem;
            .icon-xia {
                position: absolute;
                top: 0;
                right: 0;
                line-height: 1.1rem;
                color: #000;
                z-index: 1;
            }
        }
        .time {
            width: 50%;
            z-index: 20;
        }
        .hotel {
            width:50%;
            .hotelInput {
                height: 0.6667rem;
                padding: 0 0.2667rem;
                text-align: center;
                width: ~"calc(100% - 16px)";
                box-sizing: border-box;
                border: none;
            }
            &.show {
                overflow: visible;
                .icon-xia {
                    transform: rotate(180deg);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// dateHotel.vue?4489e44c